import React, { Component, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';

import {
  NamedLink,
  IconRightArrow,
  IconLeftArrow
} from '../../components';

import css from './SectionCategoryCarousel.css';

const bassinetImage = 'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/landing-page-images/bassinet-min.jpg';
const breastpumpImage = 'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/landing-page-images/breastpump-min.jpg';
const carrierImage = 'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/landing-page-images/carrier-min.jpg';
const carseatImage = 'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/landing-page-images/carseat-min.jpg';
const pramsstrollerImage = 'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/landing-page-images/pramsstroller-min.jpg';
const travelImage = 'https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/landing-page-images/travel-min.jpg';

class CategoryImage extends Component {
  render() {
    const { alt, ...rest } = this.props;
    return <img alt={alt} {...rest} />;
  }
}
const LazyImage = lazyLoadWithDimensions(CategoryImage);

const categoryLink = (name, image, searchQuery) => {
  const nameText = <span className={css.categoryName}>{name}</span>;
  return (
    <NamedLink name="SearchPage" to={{ search: searchQuery }} className={css.category}>
      <div className={css.imageWrapper}>
        <img src={image} alt={name} className={css.categoryImage} />
      </div>
      <div className={css.linkText}>
        <FormattedMessage
          id="SectionCategoryCarousel.listingsInCategory"
          values={{ category: nameText }}
        />
      </div>
    </NamedLink>
  );
};

const SectionCategoryCarousel = props => {
  const { rootClassName, className } = props;
  const categoryCarousel = useRef();
  const [isScrolling, setIsScrolling] = useState(false);

  const classes = classNames(rootClassName || css.root, className);
  const leftBtn = classNames(css.button, css.leftButton, isScrolling ? css.isScrolling : "");
  const rightBtn = classNames(css.button, css.rightButton, isScrolling ? css.isScrolling : "");

  const scrollCarousel = useRef();

  useEffect(() => {
    return () => {
      clearTimeout(scrollCarousel.current);
    }
  }, [])

  const goLeft = async () => {
    setIsScrolling(true);
    let i = categoryCarousel.current.scrollLeft;
    while (i > categoryCarousel.current.scrollLeft - 220) {
      await new Promise(resolve => {
        scrollCarousel.current = setTimeout(() => {
          categoryCarousel.current.scrollLeft = i;
          i -= 5;
          resolve();
        }, 0)
      })
    }
    setIsScrolling(false);
  }

  const goRight = async () => {
    setIsScrolling(true);
    let i = categoryCarousel.current.scrollLeft;
    while (i < categoryCarousel.current.scrollLeft + 220) {
      await new Promise(resolve => {
        scrollCarousel.current = setTimeout(() => {
          categoryCarousel.current.scrollLeft = i;
          i += 5;
          resolve();
        }, 0)
      })
    }
    setIsScrolling(false);
  }

  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionCategoryCarousel.title" />
      </div>
      <div ref={categoryCarousel} className={css.categories}>
        {categoryLink(
          'Rocking Bassinets',
          bassinetImage,
          '?bounds=-14.23900234%2C157.12826386%2C-45.19455275%2C133.39779511&pub_category=cotsAndBassinets&pub_subCategory=rockingBassinets'
        )}
        {categoryLink(
          'Prams and Strollers',
          pramsstrollerImage,
          '?bounds=-14.23900234%2C157.12826386%2C-45.19455275%2C133.39779511&pub_category=pramsStrollers'
        )}
        {categoryLink(
          'Travel cots',
          travelImage,
          '?bounds=-14.23900234%2C157.12826386%2C-45.19455275%2C133.39779511&pub_category=cotsAndBassinets&pub_subCategory=travelCots'
        )}
        {categoryLink(
          'Car seats',
          carseatImage,
          '?bounds=-14.23900234%2C157.12826386%2C-45.19455275%2C133.39779511&mapSearch=true&pub_category=carSeats'
        )}
        {categoryLink(
          'Breast pumps',
          breastpumpImage,
          '?bounds=-14.23900234%2C157.12826386%2C-45.19455275%2C133.39779511&pub_category=breastPumps&pub_subCategory=breastPumps'
        )}
        {categoryLink(
          'Carriers',
          carrierImage,
          '?bounds=-14.23900234%2C157.12826386%2C-45.19455275%2C133.39779511&pub_category=travelAccessories&pub_subCategory=carriers'
        )}
      </div>
      <div className={leftBtn} onClick={goLeft}> <IconLeftArrow /> </div>
      <div className={rightBtn} onClick={goRight}> <IconRightArrow /> </div>
    </div>
  );
};

SectionCategoryCarousel.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionCategoryCarousel.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionCategoryCarousel;
